// 1
gsap.set(".co-membership-1-image img", { y: 0, scale: 1.2 });
gsap.to(".co-membership-1-image img", {
    duration: 0.75,
    ease: "Power2.inOut",
    y: 0,
    scale: 1,
    opacity: 1
});
gsap.set(".co-membership-1-ani-2", { y: 0, scale: 1.25 });
gsap.to(".co-membership-1-ani-2", {
    duration: 0.75,
    ease: "Power2.inOut",
    y: 0,
    scale: 1,
    opacity: 1,
    stagger: 0.15,
    delay: 0.15
});
gsap.set(".co-membership-1-ani-1", { y: 0, scale: 1 });
gsap.to(".co-membership-1-ani-1", {
    duration: 1,
    ease: "Power1.in",
    y: 0,
    scale: 1,
    opacity: 1,
    delay: 0.5
});
gsap.to(".co-membership-1-image", {
    scrollTrigger: {
        start: "top top",
        end: "bottom top",
        trigger: "body",
        endTrigger: ".co-membership-1",
        scrub: true
    },
    top: "-10%"
});
// 2
gsap.set(".co-membership-2-ani-1", { y: 0, scale: 1.2 });
gsap.to(".co-membership-2-ani-1", {
    scrollTrigger: {
        start: "top 50%",
        end: "bottom top",
        trigger: ".co-membership-2",
    },
    duration: 0.75,
    ease: "Power2.inOut",
    y: 0,
    scale: 1,
    opacity: 1,
    stagger: 0.1
});
// 3
gsap.set(".co-membership-3-image img", { y: 0, scale: 1.2 });
gsap.to(".co-membership-3-image img", {
    scrollTrigger: {
        start: "top 50%",
        end: "bottom top",
        trigger: ".co-membership-3",
    },
    duration: 0.75,
    ease: "Power2.inOut",
    y: 0,
    scale: 1,
    opacity: 1
});
gsap.to(".co-membership-3-image", {
    scrollTrigger: {
        start: "top bottom",
        end: "bottom top",
        trigger: ".co-membership-3",
        scrub: true
    },
    top: "-20%"
});
gsap.set(".co-membership-3-ani-1", { y: 0, scale: 1.25 });
gsap.to(".co-membership-3-ani-1", {
    scrollTrigger: {
        start: "top 50%",
        end: "bottom top",
        trigger: ".co-membership-3",
    },
    duration: 0.75,
    ease: "Power2.inOut",
    y: 0,
    scale: 1,
    opacity: 1,
    stagger: 0.15,
    delay: 0.15
});
// 4
gsap.to('.co-product-dec-5', {
  scrollTrigger: {
    trigger: '.co-product-dec-5',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
(function() {
  'use strict';
  const flkty = new Flickity('.co-product-dec-5-slider', {
    pageDots: false, 
    draggable: true,
    wrapAround: true,
    prevNextButtons: false,
    cellAlign: "center",
    contain: true,
    on: {

    }
  });
})();